import * as validators from 'vuelidate/lib/validators';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import { isNumber } from 'lodash';

const { valorUS } = FormatMixin.methods;

export const requiredStringNumber = (value) => valorUS(value) > 0;
export const requiredTotalStringNumber = (value) => valorUS(value) > 0.0;
export const numericStringNumber = (value) => isNumber(valorUS(value));
export const isValidICMSST = (value, vm) => valorUS(value) <= valorUS(vm.vBCST);
export const isValidICMSSTRetido = (value, vm) => valorUS(value) <= valorUS(vm.vBCSTRet);
export const isValidFCPST = (value, vm) => valorUS(value) <= valorUS(vm.vBCFCPST);
export const requiredTax = (tax) => {
  if (!tax) return false;
  return 'id' in tax;
};
export const { required, minLength, numeric } = validators;
